import { render, staticRenderFns } from "./Teammates.vue?vue&type=template&id=203b4b7b&scoped=true&"
import script from "./Teammates.vue?vue&type=script&lang=js&"
export * from "./Teammates.vue?vue&type=script&lang=js&"
import style0 from "./Teammates.vue?vue&type=style&index=0&id=203b4b7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203b4b7b",
  null
  
)

export default component.exports